"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Föstudag",
    "MONDAY": "Mánudagur",
    "SATURDAY": "Laugardag",
    "SUNDAY": "Sunnudag",
    "THURSDAY": "Fimmtudag",
    "TUESDAY": "Þriðjudag",
    "WEDNESDAY": "Miðvikudag",
    "and": "og",
    "day": "dagur",
    "day_one": "dagur",
    "day_other": "daga",
    "day_plural": "daga",
    "freeOfCharge": "Ókeypis",
    "hour_one": "klukkustund",
    "hour_one_plural": "klukkustundir",
    "hour_other": "klukkustundir",
    "minute": "mínútu",
    "minute_one": "mínútu",
    "minute_other": "mínútur",
    "ocpiRestrictionsAfterDuration": "Eftir {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Milli {{minDuration}} og {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Fyrsta {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Þegar orkunotkun er yfir {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Þegar orkunotkun á milli {{minKwh}} og {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Þegar orkunotkun minni en {{maxKwh}}",
    "session": "fundur",
    "theDay": "dagur",
    "theDay_one": "dagur",
    "theDay_other": "daga",
    "theHour": "klukkustund",
    "theHour_one": "klukkustund",
    "theHour_other": "klukkustundir",
    "theMinute": "mínútu",
    "theMinute_one": "mínútu",
    "theMinute_other": "mínútur"
};
